'use client';

import { useState } from 'react';
import { ControlValues } from '@/types/api';
import { Check, Link } from 'lucide-react';
import './ShareButton.scss';

interface ShareButtonProps {
  controlValues: ControlValues;
  className?: string;
}

export default function ShareButton({ controlValues, className = '' }: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    try {
      // Get current URL without query params
      const baseUrl = window.location.origin + window.location.pathname;
      
      // Build query string from control values
      const params = new URLSearchParams();
      Object.entries(controlValues).forEach(([name, value]) => {
        params.set(name, String(value));
      });
      
      // Create shareable URL
      const shareUrl = `${baseUrl}?${params.toString()}`;
      
      // Copy to clipboard
      await navigator.clipboard.writeText(shareUrl);
      
      // Show success feedback
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy URL:', error);
    }
  };

  return (
    <button 
      className={`share-button ${className} ${copied ? 'copied' : ''}`}
      onClick={handleShare}
      title="Copy shareable URL with current settings"
    >
      {copied ? (
        <>
          <Check size={16} />
          <span>Copied!</span>
        </>
      ) : (
        <>
          <Link size={16} />
          <span>Share</span>
        </>
      )}
    </button>
  );
}
